import { Meeting } from '../model/meetingInterfaces'
import { MeetingResponse } from './meetingApiInterfaces'

export const meetingAdapter = (meeting: MeetingResponse): Meeting => {
  return {
    id: meeting.id,
    zoomId: meeting.zoomId,
    url: meeting.url,
    title: meeting.title,
    startTime: meeting.startTime,
    summary: meeting.summary,
    transcript: meeting.transcript,
    assistContext: meeting.assistContext,
    metadata: meeting.metadata,
    participants: meeting.participants,
    botStatus: meeting.botStatus,
  }
}
